import { graphql } from "react-relay";

export const QUERY = graphql`
	query selectUserFieldTable_Query(
		$nameOrEmail: String
		$accountId: ID
		$after: String
		$first: Int
	) {
		...selectUserFieldTable_QueryFragment
			@arguments(
				nameOrEmail: $nameOrEmail
				accountId: $accountId
				after: $after
				first: $first
			)
	}
`;

export const QUERY_FRAGMENT = graphql`
	fragment selectUserFieldTable_QueryFragment on Query
	@refetchable(queryName: "selectUserFieldTable_Refetch")
	@argumentDefinitions(
		nameOrEmail: { type: "String" }
		accountId: { type: "ID" }
		after: { type: "String" }
		first: { type: "Int" }
	) {
		Admin {
			Auth {
				SelectUsers(
					filterByNameOrEmail: $nameOrEmail
					filterByAccountId: $accountId
					after: $after
					first: $first
				) @connection(key: "selectUserField_QueryFragment_SelectUsers") {
					pageInfo {
						hasNextPage
						hasPreviousPage
						startCursor
						endCursor
					}
					edges {
						node {
							id
							name
							email
							activated
						}
					}
				}
			}
		}
	}
`;
